/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Evaporator2 } from "./modelEvaporator2";

class ControllerEvaporator2 extends ControllerModel {
  constructor() {
    super("ControllerEvaporator2");

    this.setNewNode = (callback) => {
      let evaporator2 = new Evaporator2();
      evaporator2.decorate(callback);

      this.addNode(evaporator2);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let evaporator2 = new Evaporator2();
      evaporator2.copyFrom(node);
      evaporator2.decorate(callback);
      this.addNode(evaporator2);
    };

    this.getProperties = async (node) => {
      let n = new Evaporator2();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Evaporator2();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerEvaporator2 };
